module.exports = __webpack_public_path__ + "static/yummin_case_study-55874fb7fb6e5db3a3ab7257d5cb5baa.png";